import { getMUICache, appendStyleSheet, fetchAnchorValue,GetIconsSprites } from '../../../common/utils';
import { CacheProvider } from '@emotion/react';
// import { FrontAwesomeIcon } from '@fortawesome/react-frontawesome';
// import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import "./RhsHomeThree.css";

const Card = (props: any) => {
  const { item,showAuthorName,showHeading, anchorLinksValue } = props;
  const { hl, au, wu } = item;
  const cache = getMUICache();
  let styles = require("./RhsHomeThree.css");
  appendStyleSheet("RhsHomeThree", styles);
 
  return (
    <CacheProvider value={cache}>
        {/* <div style={{ backgroundColor: props.cardBGColor }}> </div> */}
          {showHeading && <div className='ThemeThreeRhsHeadingWrap'>
            <p className='ThemeThreeRhsHomeHeading themeThreeCommonComponentsHeading' style={{ color: props.mainHeadingColor }}>{props.mainHeading}</p>
          </div>}
            <a href={wu} target={fetchAnchorValue(anchorLinksValue, wu)}  className='themeThreeRhsHomeWraper'>
              <div className='AngleIconWrap'>
              {/* <FrontAwesomeIcon icon={faAngleRight} /> */}
              <div className='bg-Keyboard arrow right_T3' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
              </div>
              <div className='themeThreeRhsHomeContentWraper'>
                <div className='themeThreeRhsHomeTitle'>
                  {hl}
                </div>
                {showAuthorName && <div className='themeThreedateAgencyWrap'>
                    <p className='themeThreeHeroLayoutDateTimeAgency'>By <span>{au}</span></p>
                    </div>
                     }
              </div>
              {/* <div className='themeThreeRhsHomeImageWraper'>
                  {isImageSizeBlank(imageid) ? <img src={getImageUrl(id, getImageSize(imageid), 265, 199, "", false, props.CONSTANTS)} /> :
                  <img src={GetFallBackImage()}/>
                  }
                  </div> */}
            </a>
       


    </CacheProvider>
  )
}
export default Card;